import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//Heramientas externas
import Swal from 'sweetalert2';
//helpers
import { UserHelper } from 'src/app/helpers/user';
//modelos
import { CardModel } from 'src/app/models/card.model';
import { UserModel } from 'src/app/models/user.model';
import { CardPrepaidModel } from 'src/app/models/cardPrepaid.model';
import { MembershipModel } from 'src/app/models/membership.model';

//Servicios
import { PaymentsService } from 'src/app/services/payments.service';
import { MembershipsService } from 'src/app/services/memberships.service';
import { CouponsService } from 'src/app/services/coupons.service';
//para las constantes
import { environment } from '../../../environments/environment';

import { AuthService } from '../../services/auth.service';
import { Observable } from 'rxjs';
import { CommonHelper } from 'src/app/helpers/common';

declare var OpenPay: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  private user: UserModel;
  private card: CardModel;
  public membership: MembershipModel;
  private cardPrepaid:CardPrepaidModel;
  private deviceSessionId: string;
  private tokenId: string =  '';
  private errors: string[];
  public geoLocation = '';

  //necesario para los sistemas de venta
  private environment = environment;
  private baseRoute: string = window.location.origin;
  private reference: string;
  public paymentOpenpay = false;
  public paymentPaypal = false;
  public formPaymentStatus:boolean = true;
  private language: string = CommonHelper.storeLanguage;

  public isMX: boolean;

  constructor(userHelper: UserHelper,
    private auth : AuthService,
    private payments: PaymentsService,
    private memberships: MembershipsService,
    private commonHelper: CommonHelper,
    private coupons:CouponsService,
    private route: ActivatedRoute,
    private router: Router) {

    //obtenemos los datos del usuario
    this.user = userHelper.getUser();

    if(this.route.params['value'].membership_id){//validamos la membresia para saber si es valida para ese país
      this.validateMembership(this.route.params['value'].membership_id);
    }
  }


  ngOnInit() {
    this.card = new CardModel();
    this.cardPrepaid = new CardPrepaidModel();

    //obtenemos los datos de la membresía
    this.memberships.getById(this.route.params['value'].membership_id).subscribe(membership => {

      if(this.language == 'en'){
        membership.title = membership.title_en;
        membership.description = membership.description_en;
      };
      this.membership = new MembershipModel(membership);
      console.log(this.membership.id);

      //creamos la variable de referencia para paypal y openpay
      this.reference = this.user.id + '-' + this.membership.id +'-' + this.generateRandomString(8)

      //inicializamos el SDK de openpay
      OpenPay.setId(this.environment.openpayId);
      OpenPay.setApiKey(this.environment.openpayPK);
      OpenPay.setSandboxMode(this.environment.openpaySandboxMode);

      this.deviceSessionId = OpenPay.deviceData.setup("payment-form", "deviceIdHiddenFieldName");

    },(err) => {
      this.router.navigateByUrl('/home');
    });
  }

  paymentSubmit(form: NgForm){

    if(form.invalid && !this.formPaymentStatus ){ return; }

    Swal.fire({
      allowOutsideClick: false,
      type:'info',
      text: this.commonHelper.getTranslation('errors.pleaseWait'),
      confirmButtonText: this.commonHelper.getTranslation('modal.btnOk')
    });
    Swal.showLoading();

    this.errors = [];

    if (!OpenPay.card.validateCardNumber(this.card.cardNumber)) this.errors.push(this.commonHelper.getTranslation('checkout.cardNumberInvalid'));

    if (!OpenPay.card.validateCVC(this.card.cvv2)) this.errors.push(this.commonHelper.getTranslation('checkout.cardCodeInvalid'));

    if (!OpenPay.card.validateExpiry(this.card.expirationMonth, '20'+this.card.expirationYear)) {
      this.errors.push(this.commonHelper.getTranslation('checkout.cardExpireInvalid'));
    };

    if(this.errors.length < 1){
      OpenPay.token.extractFormAndCreate('payment-form', (response) => {

        //success callback
        var tokenId = response.data.id;
        var deviceDataId = OpenPay.deviceData.setup("formId");

        this.tokenId = tokenId;

        var json = {
          'firstname':this.card.holderName,
          'lastname':" ",
          'telephone':this.card.telephone,
          'email':this.card.email,
          'reference': this.reference,
          'token_id':this.tokenId,
          'deviceIdHiddenFieldName':this.deviceSessionId,
          'deviceDataId': deviceDataId,
        }

        this.payments.openpayCharge(json).subscribe(resp => {

          localStorage.setItem('paymentData',JSON.stringify(resp['response'].data));
          window.location.href = resp['response'].data.redirect_url;

        },(err) => {
          Swal.fire({
            type:'error',
            title:'',
            text: err.error.response.message,
            confirmButtonText: this.commonHelper.getTranslation('modal.btnOk')
          });
          console.log("ERROR EN EL PAGO:",err);
        });

      }, (error) => {
        //error callback
        console.log("Error:",error);
      });
    }else{
      console.log("Error:",this.errors);
      Swal.fire({
        type:'error',
        title:this.commonHelper.getTranslation('checkout.titleModal'),
        text: this.errors.join("  "),
        confirmButtonText: this.commonHelper.getTranslation('modal.btnOk')
      });
    }

  }

  prepaidSubmit(form: NgForm){
    if(!form.invalid && this.formPaymentStatus){

      var card = {
        'code': this.cardPrepaid.code,
        'number_sheet': this.cardPrepaid.number_sheet
      };
      Swal.fire({
        allowOutsideClick: false,
        type:'info',
        text: this.commonHelper.getTranslation('errors.pleaseWait'),
        confirmButtonText: this.commonHelper.getTranslation('modal.btnOk')
      });
      Swal.showLoading();

      this.coupons.get(card).subscribe(res =>{

        var user = JSON.parse(localStorage.getItem('user'));
        var card = {
          'email': this.cardPrepaid.email,
          'code':  this.cardPrepaid.code,
          'phone':  this.cardPrepaid.phone,
          'user_id': user.id,
          'number_sheet': this.cardPrepaid.number_sheet,
          'membership_id': this.membership.id,
          'total': res['response'].data.price,
          'title': res['response'].data.title
        }
        this.coupons.post(card).subscribe(payment =>{
           let order_id = payment['response'].data.payment_id;
           var transaction = {
            'email': card.email,
            'code':  card.code,
            'phone':  card.phone,
            'user_id': user.id,
            'number_sheet': card.number_sheet,
            'membership_id': this.membership.id,
            'total': card.total,
            'order_id' : order_id
           }

           localStorage.setItem('paymentData',JSON.stringify(transaction));
           window.location.href = 'checkout/success/';

        });
        console.log("request_api=>",user);
      }, (err) => {
        Swal.fire({
          type:'error',
          title:'',
          text: this.commonHelper.getTranslation('checkout.codeInvalid'),
          confirmButtonText: this.commonHelper.getTranslation('modal.btnOk')
        });
        console.log('error',err);
      });
    }
  }

  private generateRandomString(length) : string {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  async validateMembership(membership){
    const resp = await this.compareMemberships(membership);
  }

  compareMemberships(membership:number){

      //1.- obtenemos la ubicacion
      this.auth.geolocation().subscribe((resp) => {
        console.log(`Geo zona cliente  ${resp['response']['data'].name_en}`);
        this.geoLocation = resp['response']['data'].iso2;
        this.isMX = resp['response']['data'].name_en == 'Mexico';

        //2.- obtenemos las membresias disponibles por país.
        this.memberships.getByCountry(resp['response']['data'].name_en).subscribe((memberships) => {
          console.log(`Membresias para geo zona ${ memberships.id} y membresia seleccionada: ${ membership }`);

          //3.- comparamos la membresia obtenida y la membresia valida para el usuario
          if(membership === memberships.id){

            console.log(`Membresia valida`);
            memberships.payment_methods.forEach(element => {
              console.log(element);
              if (element == "paypal") {
                this.paymentPaypal = true;
              }else if(element == "openpay"){
                this.paymentOpenpay = true;
              }
            });

          }else{
            console.log(`Membresia invalida`);
            this.router.navigateByUrl('/home');
          }

        },(err)=>{
          console.log("memberships exception:",err);
        });

      }, (err)=>{
        console.log("geolocation exception:",err);
      });

  }

  paymentValid(isValid){
    this.formPaymentStatus = isValid;
  }

}
